module.exports = __webpack_public_path__ + "img/juece.915d7a23.png";